import { z } from 'zod';

export const getMWRouteTypesSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
  })
);

export type GetMWRouteTypes = z.infer<typeof getMWRouteTypesSchema>;
